export default "__VITE_ASSET__CoXiIYcp__"